'use strict';

import get from 'lodash/get';
// @ts-ignore
import {sanitizeChatMessage} from '@techsee/techsee-common/lib/utils';
import {UrlUtilsService} from '@techsee/techsee-client-services/lib/services/UrlUtilsService';
import {EventLogConstant as LogEvents} from '../../constants/events/event-log.constant';
import {IEventLogService as IEventLogServiceInfra} from '@techsee/techsee-client-infra/lib/services/EventLogService';
import {EVENT_SOURCES, EVENT_LEVELS} from '@techsee/techsee-common/lib/constants/event-logs.constants';

export interface IEventLogService {
    room: string;
    userId: string;
    SMSInvited(meta: object): Promise<void>;
    connectivityCheck(meta: object): Promise<void>;
    emailInvited(): Promise<void>;
    savingHistoryImage(meta: object): Promise<void>;
    savingLibraryImage(meta: object): Promise<void>;
    dashboardSendingImage(meta: object): Promise<void>;
    openingLibraryDialog(meta: object): Promise<void>;
    savingResource(meta: object): Promise<void>;
    savingSnapshot(meta: object): Promise<void>;
    uploadingLocalImage(meta: object): Promise<void>;
    uploadingClipboardImage(meta: object): Promise<void>;
    imageUploadStarted(meta: object): Promise<void>;
    imageUploadSuccess(meta: object): Promise<void>;
    imageUploadFailed(meta: object): Promise<void>;
    imageSendingFailed(meta: object): Promise<void>;
    agentImageDownloadStarted(meta: object): Promise<void>;
    agentImageDownloadSuccess(meta: object): Promise<void>;
    agentImageDownloadFailed(meta: object): Promise<void>;
    agentLoadedCustomerImage(meta: object): Promise<void>;
    retryingImageDownload(meta: object): Promise<void>;
    videoDownloadFailed(meta: object): Promise<void>;
    videoReady(): Promise<void>;
    videoStreamFailed(meta: object): Promise<void>;
    failedToStartRecording(meta: object): Promise<void>;
    failedToStopRecording(meta: object): Promise<void>;
    mouseShareActivated(): Promise<void>;
    cameraOpened(): Promise<void>;
    idleNotification(): Promise<void>;
    opentok(meta: object): Promise<void>;
    opentokError(meta: object): Promise<void>;
    turn(meta: object): Promise<void>;
    turnError(meta: object): Promise<void>;
    clientLocation(meta: object): Promise<void>;
    clientLocationDenied(): Promise<void>;
    clientLocationError(): Promise<void>;
    clientLocationAddress(meta: object): Promise<void>;
    isDeviceSupported(meta: object): Promise<void>;
    isDeviceSupportedError(meta: object): Promise<void>;
    clientLocationAddressError(): Promise<void>;
    uncaughtException(meta: object): Promise<void>;
    roomCancelled(): Promise<void>;
    mobileDisconnected(): Promise<void>;
    videoBandwidthStabilized(meta: object): Promise<void>;
    lowVideoBandwidthDetected(meta: object): Promise<void>;
    connectivityDifficulties(): Promise<void>;
    imageUploadReason(meta: object): Promise<void>;
    photoReason(meta: object): Promise<void>;
    agentSwitchedToImageUpload(): Promise<void>;
    agentSwitchedToVideoStream(): Promise<void>;
    agentSwitchedToScreenShare(): Promise<void>;
    agentSwitchedToCoBrowsing(): Promise<void>;
    agentSwitchedToPhoto(): Promise<void>;
    agentScreenshotFailed(meta: object): Promise<void>;
    webRTCSupported(meta: object): Promise<void>;
    dashboardModuleLoaded(meta: object): Promise<void>;
    dashboardInviteViewLoaded(meta: object): Promise<void>;
    dashboardMainViewLoaded(meta: object): Promise<void>;
    lowBandwidthDialogResolution(meta: object): Promise<void>;
    userAgent(meta: object): Promise<void>;
    shareImageSaveLocallySuccess(meta: object): Promise<void>;
    shareImageSaveLocallyDownloadFailure(meta: object): Promise<void>;
    shareImageSaveLocallySaveFailure(meta: object): Promise<void>;
    shareImageCopyToClipboardSuccess(meta: object): Promise<void>;
    shareMultipleImagesCopyToClipboardSuccess(meta: object): Promise<void>;
    shareImageCopyToClipboardUploadFailure(meta: object): Promise<void>;
    shareMultipleImagesCopyToClipboardCopyFailure(meta: object): Promise<void>;
    shareImageCopyToClipboardCopyFailure(meta: object): Promise<void>;
    shareCopyTextToClipboardSuccess(meta: object): Promise<void>;
    shareCopyTextToClipboardFailure(meta: object): Promise<void>;
    shareImageFetchSignedDataFailure(meta: object): Promise<void>;
    snapshotReminderShown(meta: object): Promise<void>;
    snapshotReminderClosed(meta: object): Promise<void>;
    receivedMessage(meta: object): Promise<void>;
    audioSupportDetected(): Promise<void>;
    audioIsNotSupported(meta: object): Promise<void>;
    failedToEstablishAudioStreaming(meta: object): Promise<void>;
    sendFlashfightGuidance(meta: object): Promise<void>;
    sessionSummary(meta: object): Promise<void>;
    magicMarkerDrawingReceived(): Promise<void>;
    magicMarkerDrawingSent(): Promise<void>;
    videoRenderError(meta: object): Promise<void>;
    postResourceToSession(meta: object): Promise<void>;
    warmTransferRoomActivationSucceeded(meta: object): Promise<void>;
    warmTransferRoomActivationFailed(meta: object): Promise<void>;
    getInteractionSummaryFailed(meta: object): Promise<void>;
    getInteractionSummarySuccess(): Promise<void>;
    getInteractionSummaryPreviewsFailed(meta: object): Promise<void>;
    getInteractionSummaryPreviewsSuccess(): Promise<void>;
    desktopShareAgentRequestRemoteControl(): Promise<void>;
    desktopShareAgentStoppedRemoteControl(): Promise<void>;
    desktopShareClientApprovedRemoteControl(): Promise<void>;
    desktopShareClientStoppedRemoteControl(): Promise<void>;
    cameraApprovalGuidanceClosed(meta: object): Promise<void>;
    coBrowsingSurflySessionFailed(meta: object): Promise<void>;
    coBrowsingChangeUrl(): Promise<void>;
    coBrowsingSwitchControl(meta: object): Promise<void>;
    coBrowsingSurflySessionSuccess(): Promise<void>;
    trace(meta: object): Promise<void>;
    traceErr(meta: object): Promise<void>;
    failedToInitSophieSdk(meta: object): Promise<void>;
    libraryLoadingFailed(meta: object): Promise<void>;
    dashboardInitGlobalExceptionHandlerError(meta: object): Promise<void>;
    oldInviteEntry(meta: object): Promise<void>;
    oldInviteSessionStarted(meta: object): Promise<void>;
    visualScanInit(): Promise<void>;
    visualScanStopped(): Promise<void>;
    visualScanFailed(): Promise<void>;
    visualScanInProgress(): Promise<void>;
    sendEventLog(eventType: string | object, meta?: object): Promise<void>;
    getInteractionSummaryPreviewsVJFailed(meta: object): Promise<void>;
    getInteractionSummaryPreviewsAIFailed(meta: object): Promise<void>;
    translationsFallbackToEnglish(meta: object): Promise<void>;
}
export class EventLogService implements IEventLogService {
    private LogEvents: LogEvents;
    private _room = LogEvents.NO_ROOM;
    private _userId: string;
    private _isObserve: boolean;
    private _eventLogService: IEventLogServiceInfra;

    constructor(eventLogService: IEventLogServiceInfra) {
        this.LogEvents = LogEvents;
        this._room = LogEvents.NO_ROOM;
        this._isObserve = !!this._isObserver();
        this._userId = '';
        this._eventLogService = eventLogService;
    }

    /*
     * Getters and setters
     */
    set room(room) {
        this._room = room;
    }

    get room() {
        return this._room;
    }

    set userId(userId) {
        this._userId = userId;
    }

    get userId() {
        return this._userId;
    }

    /**
     * PRIVATE
     *
     * Posts event to event log API
     * @param  {Integer} event  Event type
     * @param  {String}  level  Event level
     * @param  {Object}  meta   Event meta data
     *
     * @return Promise object
     */
    _log(event: object | string, metaData?: object, level?: EVENT_LEVELS) {
        const meta = this._isObserve ? {...metaData, isObserve: true} : metaData;
        const type = typeof event === 'string' ? event : get(event, 'type', '');

        return this._eventLogService.addEventLog(
            type,
            this.room,
            this.userId || undefined,
            undefined,
            level,
            EVENT_SOURCES.dashboard,
            meta
        );
    }

    _isObserver() {
        return UrlUtilsService.extractQueryParamValueFromUrl(window.location.href, 'observe');
    }

    /**
     * User clicked Send button
     */
    SMSInvited(meta: object) {
        return this._log(this.LogEvents.events.SMSInvited, meta);
    }

    connectivityCheck(meta: object) {
        return this._log(this.LogEvents.events.connectivityCheck, meta, EVENT_LEVELS.info);
    }

    /**
     * User clicked Send by Email button
     */
    emailInvited() {
        return this._log(this.LogEvents.events.emailInvited);
    }

    savingHistoryImage(meta: object) {
        return this._log(this.LogEvents.events.savingHistoryImage, meta);
    }

    savingLibraryImage(meta: object) {
        return this._log(this.LogEvents.events.savingLibraryImage, meta);
    }

    dashboardSendingImage(meta: object) {
        return this._log(this.LogEvents.events.dashboardSendingImage, meta);
    }

    openingLibraryDialog(meta: object) {
        return this._log(this.LogEvents.events.openingLibraryDialog, meta);
    }

    savingResource(meta: object) {
        return this._log(this.LogEvents.events.savingResource, meta);
    }

    savingSnapshot(meta: object) {
        return this._log(this.LogEvents.events.savingSnapshot, meta);
    }

    uploadingLocalImage(meta: object) {
        return this._log(this.LogEvents.events.uploadingLocalImage, meta);
    }

    uploadingClipboardImage(meta: object) {
        return this._log(this.LogEvents.events.uploadingClipboardImage, meta);
    }

    imageUploadStarted(meta: object) {
        return this._log(this.LogEvents.events.imageUploadStarted, meta);
    }

    imageUploadSuccess(meta: object) {
        return this._log(this.LogEvents.events.imageUploadSuccess, meta);
    }

    imageUploadFailed(meta: object) {
        return this._log(this.LogEvents.events.imageUploadFailed, meta);
    }

    imageSendingFailed(meta: object) {
        return this._log(this.LogEvents.events.imageSendingFailed, meta);
    }

    agentImageDownloadStarted(meta: object) {
        return this._log(this.LogEvents.events.agentImageDownloadStarted, meta);
    }

    agentImageDownloadSuccess(meta: object) {
        return this._log(this.LogEvents.events.agentImageDownloadSuccess, meta);
    }

    agentImageDownloadFailed(meta: object) {
        return this._log(this.LogEvents.events.agentImageDownloadFailed, meta);
    }

    agentLoadedCustomerImage(meta: object) {
        return this._log(this.LogEvents.events.agentLoadedCustomerImage, meta);
    }

    retryingImageDownload(meta: object) {
        return this._log(this.LogEvents.events.retryingImageDownload, meta);
    }

    videoDownloadFailed(meta: object) {
        return this._log(this.LogEvents.events.videoDownloadFailed, meta);
    }

    videoReady() {
        return this._log(this.LogEvents.events.videoReady);
    }

    videoStreamFailed(meta: object) {
        return this._log(this.LogEvents.events.videoStreamFailed, meta);
    }

    failedToStartRecording(meta: object) {
        return this._log(this.LogEvents.events.failedToStartRecording, meta);
    }

    failedToStopRecording(meta: object) {
        return this._log(this.LogEvents.events.failedToStopRecording, meta);
    }

    /**
     * Saves mouse share event to event log
     */
    mouseShareActivated() {
        return this._log(this.LogEvents.events.mouseShareActivated);
    }

    /**
     * Mobile client opened camera
     */
    cameraOpened() {
        return this._log(this.LogEvents.events.cameraOpened);
    }

    idleNotification() {
        return this._log(this.LogEvents.events.idleNotification);
    }

    opentok(meta: object) {
        return this._log(this.LogEvents.events.opentok, meta);
    }

    opentokError(meta: object) {
        return this._log(this.LogEvents.events.opentokError, meta);
    }

    turn(meta: object) {
        return this._log(this.LogEvents.events.turn, meta);
    }

    turnError(meta: object) {
        return this._log(this.LogEvents.events.turnError, meta);
    }

    clientLocation(meta: object) {
        return this._log(this.LogEvents.events.clientLocation, meta);
    }

    clientLocationDenied() {
        return this._log(this.LogEvents.events.clientLocationDenied);
    }

    clientLocationError() {
        return this._log(this.LogEvents.events.clientLocationError);
    }

    clientLocationAddress(meta: object) {
        return this._log(this.LogEvents.events.clientLocationAddress, meta);
    }

    isDeviceSupported(meta: object) {
        return this._log(this.LogEvents.events.isDeviceSupported, meta);
    }

    isDeviceSupportedError(meta: object) {
        return this._log(this.LogEvents.events.isDeviceSupportedError, meta);
    }

    clientLocationAddressError() {
        return this._log(this.LogEvents.events.clientLocationAddressError);
    }

    uncaughtException(meta: object) {
        return this._log(this.LogEvents.events.uncaughtException, meta);
    }

    roomCancelled() {
        return this._log(this.LogEvents.events.roomCancelled);
    }

    mobileDisconnected() {
        return this._log(this.LogEvents.events.mobileDisconnected);
    }

    videoBandwidthStabilized(meta: object) {
        return this._log(this.LogEvents.events.videoBandwidthStabilized, meta);
    }

    lowVideoBandwidthDetected(meta: object) {
        return this._log(this.LogEvents.events.lowVideoBandwidthDetected, meta);
    }
    wifiScanResultScannerRun(meta: object) {
        return this._log(this.LogEvents.events.wifiScanResultScannerRun, meta);
    }

    connectivityDifficulties() {
        return this._log(this.LogEvents.events.connectivityDifficulties);
    }

    imageUploadReason(meta: object) {
        return this._log(this.LogEvents.events.imageUploadReason, meta);
    }

    photoReason(meta: object) {
        return this._log(this.LogEvents.events.photoReason, meta);
    }

    agentSwitchedToImageUpload() {
        return this._log(this.LogEvents.events.agentSwitchedToImageUpload);
    }

    agentSwitchedToVideoStream() {
        return this._log(this.LogEvents.events.agentSwitchedToVideoStream);
    }

    agentSwitchedToScreenShare() {
        return this._log(this.LogEvents.events.agentSwitchedToScreenShare);
    }

    agentSwitchedToCoBrowsing() {
        return this._log(this.LogEvents.events.agentSwitchedToCoBrowsing);
    }

    agentSwitchedToPhoto() {
        return this._log(this.LogEvents.events.agentSwitchedToPhoto);
    }

    agentScreenshotFailed(meta: object) {
        return this._log(this.LogEvents.events.agentScreenshotFailed, meta);
    }

    webRTCSupported(meta: object) {
        return this._log(this.LogEvents.events.webRTCSupported, meta);
    }

    dashboardModuleLoaded(meta: object) {
        return this._log(this.LogEvents.events.dashboardModuleLoaded, meta);
    }

    dashboardInviteViewLoaded(meta: object) {
        return this._log(this.LogEvents.events.dashboardInviteViewLoaded, meta);
    }

    dashboardMainViewLoaded(meta: object) {
        return this._log(this.LogEvents.events.dashboardMainViewLoaded, meta);
    }

    lowBandwidthDialogResolution(meta: object) {
        return this._log(this.LogEvents.events.lowBandwidthDialogResolution, meta);
    }

    userAgent(meta: object) {
        return this._log(this.LogEvents.events.userAgent, meta);
    }

    shareImageSaveLocallySuccess(meta: object) {
        return this._log(this.LogEvents.events.shareImageSaveLocallySuccess, meta);
    }

    shareImageSaveLocallyDownloadFailure(meta: object) {
        return this._log(this.LogEvents.events.shareImageSaveLocallyDownloadFailure, meta);
    }

    shareImageSaveLocallySaveFailure(meta: object) {
        return this._log(this.LogEvents.events.shareImageSaveLocallySaveFailure, meta);
    }

    shareImageCopyToClipboardSuccess(meta: object) {
        return this._log(this.LogEvents.events.shareImageCopyToClipboardSuccess, meta);
    }

    shareMultipleImagesCopyToClipboardSuccess(meta: object) {
        return this._log(this.LogEvents.events.shareMultipleImagesCopyToClipboardSuccess, meta);
    }

    shareImageCopyToClipboardUploadFailure(meta: object) {
        return this._log(this.LogEvents.events.shareImageCopyToClipboardUploadFailure, meta);
    }

    shareMultipleImagesCopyToClipboardCopyFailure(meta: object) {
        return this._log(this.LogEvents.events.shareMultipleImagesCopyToClipboardCopyFailure, meta);
    }

    shareImageCopyToClipboardCopyFailure(meta: object) {
        return this._log(this.LogEvents.events.shareImageCopyToClipboardCopyFailure, meta);
    }

    shareCopyTextToClipboardSuccess(meta: object) {
        return this._log(this.LogEvents.events.shareCopyTextToClipboardSuccess, meta);
    }

    shareCopyTextToClipboardFailure(meta: object) {
        return this._log(this.LogEvents.events.shareCopyTextToClipboardFailure, meta);
    }

    shareImageFetchSignedDataFailure(meta: object) {
        return this._log(this.LogEvents.events.shareImageFetchSignedDataFailure, meta);
    }

    snapshotReminderShown(meta: object) {
        return this._log(this.LogEvents.events.snapshotReminderShown, meta);
    }

    snapshotReminderClosed(meta: object) {
        return this._log(this.LogEvents.events.snapshotReminderClosed, meta);
    }

    receivedMessage(meta: object) {
        return this._log(this.LogEvents.events.receivedMessage, sanitizeChatMessage(meta));
    }

    audioSupportDetected() {
        return this._log(this.LogEvents.events.audioSupportDetected);
    }

    audioIsNotSupported(meta: object) {
        return this._log(this.LogEvents.events.audioIsNotSupported, meta);
    }

    failedToEstablishAudioStreaming(meta: object) {
        return this._log(this.LogEvents.events.failedToEstablishAudioStreaming, meta);
    }

    sendFlashfightGuidance(meta: object) {
        return this._log(this.LogEvents.events.flashlightGuidanceSent, meta);
    }

    sessionSummary(meta: object) {
        return this._log(this.LogEvents.events.sessionSummary, meta);
    }

    magicMarkerDrawingReceived() {
        return this._log(this.LogEvents.events.magicMarkerDrawingReceived);
    }

    magicMarkerDrawingSent() {
        return this._log(this.LogEvents.events.magicMarkerDrawingSent);
    }

    videoRenderError(meta?: object) {
        return this._log(this.LogEvents.events.videoRenderError, meta);
    }

    postResourceToSession(meta: object) {
        return this._log(this.LogEvents.events.postResourceToSession, meta);
    }

    warmTransferRoomActivationSucceeded(meta: object) {
        return this._log(this.LogEvents.events.warmTransferRoomActivationSucceeded, meta);
    }

    warmTransferRoomActivationFailed(meta: object) {
        return this._log(this.LogEvents.events.warmTransferRoomActivationFailed, meta);
    }

    getInteractionSummaryFailed(meta: object) {
        return this._log(this.LogEvents.events.getInteractionSummaryFailed, meta);
    }

    getInteractionSummarySuccess() {
        return this._log(this.LogEvents.events.getInteractionSummarySuccess);
    }

    getInteractionSummaryPreviewsFailed(meta: object) {
        return this._log(this.LogEvents.events.getInteractionSummaryPreviewsFailed, meta);
    }

    getInteractionSummaryPreviewsSuccess() {
        return this._log(this.LogEvents.events.getInteractionSummaryPreviewsSuccess);
    }

    desktopShareAgentRequestRemoteControl() {
        return this._log(this.LogEvents.events.desktopShareAgentRequestRemoteControl);
    }

    desktopShareAgentStoppedRemoteControl() {
        return this._log(this.LogEvents.events.desktopShareAgentStoppedRemoteControl);
    }

    desktopShareClientApprovedRemoteControl() {
        return this._log(this.LogEvents.events.desktopShareClientApprovedRemoteControl);
    }

    desktopShareClientStoppedRemoteControl() {
        return this._log(this.LogEvents.events.desktopShareClientStoppedRemoteControl);
    }

    cameraApprovalGuidanceClosed(meta: object) {
        return this._log(this.LogEvents.events.cameraApprovalGuidanceClosed, meta);
    }

    coBrowsingSurflySessionFailed(meta: object) {
        return this._log(this.LogEvents.events.coBrowsingSurflySessionFailed, meta);
    }
    oldInviteEntry(meta: object) {
        return this._log(this.LogEvents.events.oldInviteEntry, meta);
    }

    oldInviteSessionStarted(meta: object) {
        return this._log(this.LogEvents.events.oldInviteSessionStarted, meta);
    }

    coBrowsingChangeUrl() {
        return this._log(this.LogEvents.events.coBrowsingSurflyChangeUrl);
    }

    coBrowsingSwitchControl(meta: object) {
        return this._log(this.LogEvents.events.coBrowsingSurflySwitchControl, meta);
    }

    coBrowsingSurflySessionSuccess() {
        return this._log(this.LogEvents.events.coBrowsingSurflySessionSuccess);
    }

    trace(meta: object) {
        return this._log(this.LogEvents.events.trace, meta);
    }

    traceErr(meta: object) {
        return this._log(this.LogEvents.events.traceErr, meta);
    }

    failedToInitSophieSdk(meta: object) {
        return this._log(this.LogEvents.events.failedToInitSophieSdk, meta);
    }

    libraryLoadingFailed(meta: object) {
        return this._log(this.LogEvents.events.libraryLoadingFailed, meta);
    }

    dashboardInitGlobalExceptionHandlerError(meta: object) {
        return this._log(this.LogEvents.events.dashboardInitGlobalExceptionHandlerError, meta);
    }

    visualScanInit() {
        return this._log(this.LogEvents.events.visualScanInit);
    }

    visualScanStopped() {
        return this._log(this.LogEvents.events.visualScanStopped);
    }
    visualScanFailed() {
        return this._log(this.LogEvents.events.visualScanFailed);
    }

    visualScanInProgress() {
        return this._log(this.LogEvents.events.visualScanInProgress);
    }

    sendEventLog(eventType: string | object, meta?: object) {
        return this._log(eventType, meta, EVENT_LEVELS.error);
    }

    getInteractionSummaryPreviewsVJFailed(meta: object) {
        return this._log(this.LogEvents.events.getInteractionSummaryPreviewsVJFailed, meta);
    }

    getInteractionSummaryPreviewsAIFailed(meta: object) {
        return this._log(this.LogEvents.events.getInteractionSummaryPreviewsAIFailed, meta);
    }

    translationsFallbackToEnglish(meta: object) {
        return this._log(this.LogEvents.events.translationsFallbackToEnglish, meta);
    }
}
